import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';

import { getFormattedValue } from './BoardCardABWorkReportingHelpers';

export default function BoardCardABWorkReportingItemDetails({
  item,
  itemColumns,
}) {
  const statuses = useSelector((state) => state.statuses.statuses);

  if (!item) return null;
  return (
    <Row className="ab-work-reporting-container" style={{ marginBottom: 10, marginTop: 10 }}>
      {itemColumns.map((column) => (
        <Col span={8} key={column.dataIndex}>
          <Row justify="start">
            <div style={{ fontWeight: 600, display: 'inline-flex' }}>{column.title}:&nbsp;&nbsp;</div>
            {getFormattedValue({
              item,
              statuses,
              dataIndex: column.dataIndex,
            })}
          </Row>
        </Col>
      ))}
    </Row>
  )
}

BoardCardABWorkReportingItemDetails.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    bidItems: PropTypes.array.isRequired,
  }),
  itemColumns: PropTypes.array,
};

BoardCardABWorkReportingItemDetails.defaultProps = {
  item: null,
  itemColumns: [],
};
